<div class="h-full flex flex-col space-y-6 animate-fade-in-up font-sans">

  <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 relative overflow-hidden">
    <div class="absolute left-0 top-0 bottom-0 w-1 bg-[#1e3a8a]"></div>

    <div class="flex items-center gap-4">
      <div class="bg-blue-50 p-3 rounded-xl text-[#1e3a8a] shadow-inner">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"></path></svg>
      </div>
      <div>
        <h2 class="text-2xl font-black text-[#1e3a8a] tracking-wide uppercase">Tablero de Tareas</h2>
        <p class="text-xs text-gray-500 font-medium mt-1">Gestión ágil de actividades del proyecto</p>
      </div>
    </div>

    <div class="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
      <div class="relative group">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg class="h-4 w-4 text-gray-400 group-focus-within:text-[#ffb31c] transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/></svg>
        </div>
        <input type="text" placeholder="Buscar tarea..." class="block w-full sm:w-64 pl-10 pr-3 py-2.5 border border-gray-200 rounded-xl leading-5 bg-gray-50 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#ffb31c] focus:bg-white transition-all text-sm font-medium shadow-sm">
      </div>
      <button class="flex items-center justify-center gap-2 bg-[#1e3a8a] hover:bg-[#ffb31c] text-white hover:text-[#1e3a8a] px-5 py-2.5 rounded-xl shadow-md transition-all text-sm font-bold group">
        <svg class="w-4 h-4 transform group-hover:rotate-90 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path></svg>
        Nueva Tarea
      </button>
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-3 gap-6 flex-1 min-h-0">

    <div class="bg-gray-50/80 rounded-2xl p-4 flex flex-col border border-gray-100 shadow-inner">
      <div class="flex justify-between items-center mb-4 pb-3 border-b border-gray-200">
        <h3 class="font-black text-gray-700 uppercase tracking-widest text-sm flex items-center gap-2">
          <span class="w-2 h-2 rounded-full bg-gray-400"></span> Por Hacer
        </h3>
        <span class="bg-white border border-gray-200 text-gray-600 text-xs font-black px-2.5 py-1 rounded-lg shadow-sm">{{ porHacer.length }}</span>
      </div>

      <div class="flex-1 overflow-y-auto space-y-4 pr-1 custom-scrollbar pb-2">
        @for (t of porHacer; track t.id) {
          <div class="bg-white p-5 rounded-xl shadow-sm border border-gray-100 border-l-4 cursor-pointer hover:shadow-md hover:-translate-y-1 transition-all group"
               [class.border-l-red-500]="t.prioridad === 'Alta'" [class.border-l-[#ffb31c]]="t.prioridad === 'Media'" [class.border-l-green-500]="t.prioridad === 'Baja'">
            <div class="flex justify-between items-start mb-3">
              <span class="text-[10px] font-black text-gray-400 tracking-wider">{{ t.id }}</span>
              <span class="text-[9px] font-black uppercase px-2 py-1 rounded-md tracking-wider shadow-sm"
                    [class.bg-red-50]="t.prioridad === 'Alta'" [class.text-red-700]="t.prioridad === 'Alta'"
                    [class.bg-yellow-50]="t.prioridad === 'Media'" [class.text-yellow-700]="t.prioridad === 'Media'"
                    [class.bg-green-50]="t.prioridad === 'Baja'" [class.text-green-700]="t.prioridad === 'Baja'">
                {{ t.prioridad }}
              </span>
            </div>
            <h4 class="font-extrabold text-gray-800 text-sm mb-2 leading-snug group-hover:text-[#1e3a8a] transition-colors">{{ t.titulo }}</h4>
            <p class="text-xs font-medium text-gray-500 mb-4 line-clamp-1 bg-gray-50 p-1.5 rounded-md">{{ t.proyecto }}</p>
            <div class="flex justify-between items-center border-t border-gray-50 pt-3 mt-auto">
              <div class="w-7 h-7 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center text-[10px] font-black border border-gray-200 shadow-sm" title="{{ t.responsable }}">
                {{ t.responsable.charAt(0) }}
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="bg-blue-50/50 rounded-2xl p-4 flex flex-col border border-blue-100 shadow-inner">
      <div class="flex justify-between items-center mb-4 pb-3 border-b border-blue-200">
        <h3 class="font-black text-[#1e3a8a] uppercase tracking-widest text-sm flex items-center gap-2">
          <span class="w-2 h-2 rounded-full bg-[#ffb31c] animate-pulse"></span> En Curso
        </h3>
        <span class="bg-white border border-blue-200 text-[#1e3a8a] text-xs font-black px-2.5 py-1 rounded-lg shadow-sm">{{ enCurso.length }}</span>
      </div>

      <div class="flex-1 overflow-y-auto space-y-4 pr-1 custom-scrollbar pb-2">
        @for (t of enCurso; track t.id) {
          <div class="bg-white p-5 rounded-xl shadow-sm border border-gray-100 border-l-4 cursor-pointer hover:shadow-md hover:-translate-y-1 transition-all group"
               [class.border-l-red-500]="t.prioridad === 'Alta'" [class.border-l-[#ffb31c]]="t.prioridad === 'Media'" [class.border-l-green-500]="t.prioridad === 'Baja'">
            <div class="flex justify-between items-start mb-3">
              <span class="text-[10px] font-black text-gray-400 tracking-wider">{{ t.id }}</span>
              <span class="text-[9px] font-black uppercase px-2 py-1 rounded-md tracking-wider shadow-sm"
                    [class.bg-red-50]="t.prioridad === 'Alta'" [class.text-red-700]="t.prioridad === 'Alta'"
                    [class.bg-yellow-50]="t.prioridad === 'Media'" [class.text-yellow-700]="t.prioridad === 'Media'"
                    [class.bg-green-50]="t.prioridad === 'Baja'" [class.text-green-700]="t.prioridad === 'Baja'">
                {{ t.prioridad }}
              </span>
            </div>
            <h4 class="font-extrabold text-gray-800 text-sm mb-2 leading-snug group-hover:text-[#1e3a8a] transition-colors">{{ t.titulo }}</h4>
            <p class="text-xs font-medium text-gray-500 mb-4 line-clamp-1 bg-gray-50 p-1.5 rounded-md">{{ t.proyecto }}</p>
            <div class="flex justify-between items-center border-t border-gray-50 pt-3 mt-auto">
              <div class="w-7 h-7 rounded-full bg-[#1e3a8a] text-white flex items-center justify-center text-[10px] font-black shadow-sm ring-2 ring-[#ffb31c]/50" title="{{ t.responsable }}">
                {{ t.responsable.charAt(0) }}
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="bg-green-50/50 rounded-2xl p-4 flex flex-col border border-green-100 shadow-inner opacity-90">
      <div class="flex justify-between items-center mb-4 pb-3 border-b border-green-200">
        <h3 class="font-black text-green-700 uppercase tracking-widest text-sm flex items-center gap-2">
          <span class="w-2 h-2 rounded-full bg-green-500"></span> Terminado
        </h3>
        <span class="bg-white border border-green-200 text-green-700 text-xs font-black px-2.5 py-1 rounded-lg shadow-sm">{{ terminado.length }}</span>
      </div>

      <div class="flex-1 overflow-y-auto space-y-4 pr-1 custom-scrollbar pb-2">
        @for (t of terminado; track t.id) {
          <div class="bg-white p-5 rounded-xl shadow-sm border border-gray-100 border-l-4 cursor-pointer opacity-70 hover:opacity-100 transition-all group"
               [class.border-l-red-500]="t.prioridad === 'Alta'" [class.border-l-[#ffb31c]]="t.prioridad === 'Media'" [class.border-l-green-500]="t.prioridad === 'Baja'">
            <div class="flex justify-between items-start mb-3">
              <span class="text-[10px] font-black text-gray-400 tracking-wider line-through decoration-gray-300">{{ t.id }}</span>
              <span class="text-[9px] font-black uppercase px-2 py-1 rounded-md tracking-wider shadow-sm bg-gray-100 text-gray-500">
                Terminado
              </span>
            </div>
            <h4 class="font-extrabold text-gray-500 text-sm mb-2 leading-snug line-through decoration-gray-300">{{ t.titulo }}</h4>
            <div class="flex justify-between items-center border-t border-gray-50 pt-3 mt-4">
              <div class="w-7 h-7 rounded-full bg-green-100 text-green-700 flex items-center justify-center text-[10px] font-black shadow-sm" title="{{ t.responsable }}">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

  </div>
</div>
